import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { BookComponent } from './book.component';
import { BookEditComponent } from './book-edit/book-edit.component';
import {BookSyncComponent} from "./book-sync/book-sync.component";
import {BookSendComponent} from "./book-send/book-send.component";

export const booksRoutes: Routes = [
  {
    path: 'book',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: ':bookId/edit',
        component: BookEditComponent,
      },
      {
        path: 'sync',
        component: BookSyncComponent,
      },
      {
        path: 'send/:target',
        component: BookSendComponent,
      },
      {
        path: '',
        component: BookComponent
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/book/book.routes.ts